import { useEffect, type FC } from "react";
import { useLocation } from "react-router-dom";

/** Garante que toda troca de rota comece no topo (evita herdar scroll de agendamento/lista). */
export function scrollWindowToTop() {
  if (typeof window === "undefined") return;
  try {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  } catch {
    /* ignore */
  }
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/** Sobe agora e de novo após o próximo paint (conteúdo async / layout). */
export function scrollWindowToTopSoon() {
  scrollWindowToTop();
  requestAnimationFrame(() => {
    scrollWindowToTop();
    requestAnimationFrame(scrollWindowToTop);
  });
  window.setTimeout(scrollWindowToTop, 50);
  window.setTimeout(scrollWindowToTop, 200);
}

const ScrollToTop: FC = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // Âncoras (#faq, #grupo-avisos) devem manter o destino do hash.
    if (hash) return;
    scrollWindowToTopSoon();
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
